import React, { ReactNode } from 'react';
import CardList from '../CardList';
import TasksListItem from '../TasksListItem';

export type TasksCardListProps = {
  title?: string;
  seeAllLink?: ReactNode;
  height?: string;
  loading?: boolean;
  fallback?: ReactNode;
  tasks: any;
  onItemClick?: (item: any) => void;
  onHover?: boolean;
};

const TTasksCardList: React.FC<TasksCardListProps> = ({
  title,
  seeAllLink,
  tasks = [],
  loading = false,
  height,
  fallback,
  onItemClick,
  onHover,
}) => {
  return (
    <CardList
      title={title}
      seeAllLink={seeAllLink}
      loading={loading}
      height={height}
      fallback={fallback}
      onHover={onHover}
    >
      {tasks.length
        ? tasks.map((item, index) => (
            <TasksListItem
              key={index}
              statusText={item.status}
              assignee={item.assignee}
              assignedBy={item.assignedBy}
              section={item}
              image={item.image}
              description={item.description}
              onItemClick={(event) => {
                onItemClick && onItemClick(item);
              }}
            />
          ))
        : fallback}
    </CardList>
  );
};

export default TTasksCardList;
